import(/* webpackMode: "eager" */ "C:\\Users\\Lachlan\\Repos\\tutorcerti\\src\\app\\error.js")